import { Response } from "@/types";
import { APIRequest } from "@/utils/api";

const PrinterAPI = new APIRequest({
  baseURL: "/api/wms/v2/tms/printer",
});

export async function getPrinterCertificate(): Promise<string> {
  return PrinterAPI.get<Response<string>>({
    url: "certificate",
  }).then((res) => res.data);
}

export async function signContent(content: string): Promise<string> {
  return PrinterAPI.post<Response<string>>({
    url: "sign",
    data: { payload: content },
  }).then((res) => res.data);
}
